import { COUNTRIES_INFO } from "@app/dashboard/constants/countries";
import { PAYMOB_PRO_PRICES, SUBSCRIBED, UNSUBSCRIBED } from "@app/dashboard/constants/paymob-pro";
import type { TCountry } from "@app/dashboard/types/outerLayout/common";
import { getCountryFromDomain } from "@app/dashboard/utils/getCountryFromDomain";
import { MOBILE_BREAKPOINT } from "@app/dashboard/constants/break-points";


type TPriceKey = "ae_price" | "eg_price" | "sa_price" | "om_price" | "jo_price" | "pk_price";

const COUNTRY_PRICE_KEYS: Record<TCountry, TPriceKey> = {
  EGY: "eg_price",
  SAU: "sa_price",
  ARE: "ae_price",
  OMN: "om_price",
  JOR: "jo_price",
  PAK: "pk_price",
};

export const getPaymobProPrices = (planIndex: number) => {
  const country = "ARE";
  const priceKey = "ae_price";

  const planPrices = PAYMOB_PRO_PRICES[planIndex] as {
    monthly: Partial<Record<TPriceKey, string>>;
    annually: Partial<Record<TPriceKey, string>>;
  } | undefined;

  return {
    currency: COUNTRIES_INFO[country].currency,
    monthly: planPrices?.monthly[priceKey] || "",
    annually: planPrices?.annually[priceKey] || "",
  };
};


const BADGE_VISIBILITY_THRESHOLD = 1200;

const BTN_TEXT_THRESHOLDS: { maxWidth: number; textToHide?: string[]; elementToHide?: string[] }[] = [
  { maxWidth: 1280, textToHide: ['Try ', 'جرب ', 'Pro Trial -', 'تجربة Pro -'] },
  { maxWidth: 1250, textToHide: [' - Free', ' - مجاناً'] },
  { maxWidth: 1160, textToHide: ['Paymob Pro'] },
];

export const getBtnText = (text: string, screenWidth: number) => {
  if (screenWidth <= MOBILE_BREAKPOINT) return text;

  let result = text;

  for (const { maxWidth, textToHide } of BTN_TEXT_THRESHOLDS) {
    if (screenWidth <= maxWidth && textToHide)
      textToHide.forEach(t => result = result.replace(t, ''));
  };

  return result.trim();
};

export const isBadgeVisible = (screenWidth: number) => (
  screenWidth <= MOBILE_BREAKPOINT ||
  screenWidth > BADGE_VISIBILITY_THRESHOLD
);

export const getPaymobProStatus = (endDate: string | null) => {
  if (!endDate) return UNSUBSCRIBED;

  const endTimestamp = new Date(endDate).getTime();

  return Number.isFinite(endTimestamp) && endTimestamp > Date.now()
    ? SUBSCRIBED
    : UNSUBSCRIBED;
};

export const getPaymobProDaysLeft = (endDate: string | null) => {
  const endTimestamp = endDate ? new Date(endDate).getTime() : NaN;
  const remainingMilliseconds = endTimestamp - Date.now();
  const millisecondsPerDay = 24 * 60 * 60 * 1000;

  return Number.isFinite(endTimestamp) && remainingMilliseconds > 0
    ? Math.ceil(remainingMilliseconds / millisecondsPerDay)
    : 0;
};